import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WorkflowTask, WorkflowTaskCreate, WorkflowTaskFilter } from '../data/workflowTask';

export function createWorkflowTaskService(client: AxiosInstance) {
  return createCrudService<WorkflowTask, WorkflowTaskCreate, WorkflowTaskFilter>(
    client,
    '/workflow/WorkflowTask',
    'id',
  );
}

export type WorkflowTaskService = CrudService<WorkflowTask, WorkflowTaskCreate, WorkflowTaskFilter>;
